var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutsideTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people-21",
    "data-name": "people"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 6.8,
    rx: 2.75,
    ry: 2.86
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.68 10.1h-3.36a3.37 3.37 0 0 0 -3.51 3.22v4.35a2.49 2.49 0 0 0 1.67 2.33v5.8a2 2 0 0 0 1.84 2.07h3.36a2 2 0 0 0 1.84-2.07v-5.8a2.49 2.49 0 0 0 1.67-2.31v-4.37a3.37 3.37 0 0 0 -3.51-3.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 10.46a1.67 1.67 0 1 0 -1.61-1.67 1.64 1.64 0 0 0 1.61 1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.2 11.26h-2.4a2.68 2.68 0 0 0 -2.8 2.53v3a2 2 0 0 0 1.5 1.91v3.81a1.65 1.65 0 0 0 1.5 1.75h2.09a1.65 1.65 0 0 0 1.52-1.78v-3.84a2 2 0 0 0 1.39-1.88v-3a2.68 2.68 0 0 0 -2.8-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 10.46a1.67 1.67 0 1 0 -1.61-1.67 1.64 1.64 0 0 0 1.61 1.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.2 11.26h-2.4a2.68 2.68 0 0 0 -2.8 2.53v3a2 2 0 0 0 1.5 1.91v3.81a1.65 1.65 0 0 0 1.5 1.75h2.07a1.65 1.65 0 0 0 1.52-1.78v-3.84a2 2 0 0 0 1.41-1.88v-3a2.68 2.68 0 0 0 -2.8-2.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsideTeam);
export default __webpack_public_path__ + "static/media/OutsideTeam.44cd3473276e1b1a05d8e65b9fc3423f.svg";
export { ForwardRef as ReactComponent };